import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { WebviewCommunicationService } from '@shared/core';
import { LocalizationPipe } from '@shared/modules/localization';
import { APP_STORE_LINKS } from '../../../shared/constants/app-store-links.const';

const DISMISSED_KEY = 'pkp-app-download-banner-dismissed';
const DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000;

@Component({
  selector: 'pkp-m-app-download-banner',
  standalone: true,
  templateUrl: './app-download-banner.component.html',
  styleUrl: './app-download-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocalizationPipe, NzIconDirective],
})
export class MobileAppDownloadBannerComponent {
  private readonly webviewService = inject(WebviewCommunicationService);
  private readonly isWebviewInitialized = toSignal(
    this.webviewService.isNsWebViewInterfaceInitialized$,
    { initialValue: false },
  );
  private readonly isDismissed = signal(this.readDismissed());

  readonly stores = APP_STORE_LINKS;
  readonly isVisible = computed(
    () =>
      !this.isDismissed() && !this.webviewService.isInNativeWebView && !this.isWebviewInitialized(),
  );

  dismiss(): void {
    this.isDismissed.set(true);
    try {
      localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    } catch {
      return;
    }
  }

  private readDismissed(): boolean {
    try {
      return Date.now() - Number(localStorage.getItem(DISMISSED_KEY)) < DISMISS_TTL_MS;
    } catch {
      return false;
    }
  }
}
